/*
 * File: IsOverriddenFilter.tsx
 * Project: beaker
 * -----
 * Last Modified: 24 May 2022 5:57:41 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { LabeledValueType, RawValueType } from 'rc-tree-select/lib/TreeSelect';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setIncludeInactiveData, setReturnInactiveDataOnly } from 'redux/services/julia/productCatalogParams';
import { ReduxState, useAppDispatch } from 'redux/store';
import { FancySelect } from '../Inputs';

export const IsActiveFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();
  const { includeInactiveData, returnInactiveDataOnly } = useSelector((state: ReduxState) => state.juliaProductCatalogParams);

  const isActiveValue = (): 'TRUE' | 'FALSE' | undefined => {
    if (includeInactiveData === undefined && returnInactiveDataOnly === undefined) {
      return 'TRUE';
    }

    if (includeInactiveData && returnInactiveDataOnly === undefined) {
      return undefined;
    }

    if (includeInactiveData === undefined && returnInactiveDataOnly) {
      return 'FALSE';
    }
  };

  /* ******************** Functions ******************** */
  const handleChange = (value: RawValueType | LabeledValueType): void => {
    switch (value) {
      case undefined:
        dispatch(setIncludeInactiveData(true));
        dispatch(setReturnInactiveDataOnly(undefined));
        break;

      case 'TRUE':
        dispatch(setIncludeInactiveData(undefined));
        dispatch(setReturnInactiveDataOnly(undefined));
        break;

      case 'FALSE':
        dispatch(setIncludeInactiveData(undefined));
        dispatch(setReturnInactiveDataOnly(true));
        break;
    }
  };

  useEffect(() => {
    return (): void => {
      dispatch(setIncludeInactiveData(true));
      dispatch(setReturnInactiveDataOnly(undefined));
    };
  }, [dispatch]);

  return (
    <FancySelect
      placeholder="Is Active"
      onChange={handleChange}
      value={isActiveValue()}
      options={[
        { value: 'TRUE', label: 'TRUE' },
        { value: 'FALSE', label: 'FALSE' }
      ]}
    />
  );
};
